const l = (i) => {
  try {
    return new URL(i);
  } catch {
  }
  if (typeof window > "u")
    throw new Error(
      `Invalid url: "${i}" is relative and no browser context is available to resolve it against.`
    );
  return new URL(i.toString(), window.location.origin);
}, o = "https://public-api.twinkl.co.uk/curriculum-architect", t = (i = ":id") => i !== null ? `${o}/v1/curriculum/${i}` : `${o}/v1/curriculum`, c = `${o}/v1/curricula`, d = `${o}/v1/curriculum/duplicate`, e = () => `${o}/v1/subjects`, m = (i = ":id") => `${e()}/${i}`, s = (i = ":curriculum_id") => `${o}/v1/curriculum/${i}/subjects`, r = (i = ":curriculum_id", n = ":id") => `${s(i)}/${n}`, p = (i = ":curriculum_id", n = ":subject_id") => `${o}/v1/curriculum/${i}/subjects/${n}/plan`, h = (i = ":id") => `${o}/unit-preview/${i}`, I = (i = ":id") => `${o}/v1/unit-plan/${i}`, u = (i = ":id") => `${o}/v1/resource-pack-content/${i}`, P = `${o}/v1/current-user`, a = "https://public-api.twinkl.co.uk", N = (i = ":id") => `${a}/resources/${i}/curriculum-scheme`, L = (i) => {
  const n = l(`${a}/search/curriculum-schemes`);
  return n.search = new URLSearchParams(i).toString(), n.toString();
}, g = {
  BASE_API_URL: o,
  CURRENT_USER_PATH: P,
  CURRICULUM_PATH: t,
  CURRICULUM_LIST_PATH: c,
  DUPLICATE_CURRICULUM_PATH: d,
  SUBJECT_PATH: r,
  GENERIC_SUBJECT_LIST_PATH: e,
  GENERIC_SUBJECT_PATH: m,
  SUBJECT_LIST_PATH: s,
  SUBJECT_PLAN_PATH: p,
  UNIT_PREVIEW_PATH: h,
  UNIT_PLAN_PATH: I,
  RESOURCE_PACK_CONTENT_PATH: u,
  external: {
    TWINKL_RESOURCE_API_URL: N,
    TWINKL_SEARCH_API_URL: L
  }
}, D = {
  SIXTY_SECOND_READ: {
    monolithId: "1",
    monolithName: "60 Second Read",
    caDisplayLabel: "",
    icon: "description",
    slug: "sixty-second-read",
    isPinned: !1
  },
  ACTIVITY_CARDS: {
    monolithId: "2",
    monolithName: "Activity Cards",
    caDisplayLabel: "",
    icon: "description",
    slug: "activity-cards",
    isPinned: !1
  },
  ACTIVITY_MAT: {
    monolithId: "3",
    monolithName: "Activity Mat",
    caDisplayLabel: "",
    icon: "description",
    slug: "activity-mat",
    isPinned: !1
  },
  ACTIVITY_PACK: {
    monolithId: "4",
    monolithName: "Activity Pack",
    caDisplayLabel: "",
    icon: "description",
    slug: "activity-pack",
    isPinned: !1
  },
  ACTIVITY_PLANNING_AND_CONTINUOUS_PROVISION_IDEAS: {
    monolithId: "5",
    monolithName: "Activity Planning and Continuous Provision Ideas",
    caDisplayLabel: "",
    icon: "description",
    slug: "activity-planning-and-continuous-provision-ideas",
    isPinned: !0
  },
  ACTIVITY_PLANNING_AND_CONTINUOUS_PROVISION_IDEAS_RESOURCE_PACK: {
    monolithId: "6",
    monolithName: "Activity Planning and Continuous Provision Ideas Resource Pack",
    caDisplayLabel: "",
    icon: "description",
    slug: "activity-planning-and-continuous-provision-ideas-resource-pack",
    isPinned: !0
  },
  ACTIVITY_SHEET: {
    monolithId: "7",
    monolithName: "Activity Sheet",
    caDisplayLabel: "",
    icon: "description",
    slug: "activity-sheet",
    isPinned: !1
  },
  ADULT_INPUT_PLAN: {
    monolithId: "8",
    monolithName: "Adult Input Plan",
    caDisplayLabel: "",
    icon: "description",
    slug: "adult-input-plan",
    isPinned: !0
  },
  APP_GAME: {
    monolithId: "9",
    monolithName: "App Game",
    caDisplayLabel: "",
    icon: "description",
    slug: "app-game",
    isPinned: !1
  },
  AREA_PLAN: {
    monolithId: "10",
    monolithName: "Area Plan",
    caDisplayLabel: "",
    icon: "description",
    slug: "area-plan",
    isPinned: !0
  },
  ASSESSMENT_PACK: {
    monolithId: "11",
    monolithName: "Assessment Pack",
    caDisplayLabel: "",
    icon: "description",
    slug: "assessment-pack",
    isPinned: !0
  },
  ASSESSMENT_RUBRIC: {
    monolithId: "12",
    monolithName: "Assessment Rubric",
    caDisplayLabel: "",
    icon: "description",
    slug: "assessment-rubric",
    isPinned: !0
  },
  ASSESSMENT_SHEET: {
    monolithId: "13",
    monolithName: "Assessment Sheet",
    caDisplayLabel: "",
    icon: "description",
    slug: "assessment-sheet",
    isPinned: !0
  },
  ASSESSMENT_SPREADSHEET: {
    monolithId: "14",
    monolithName: "Assessment Spreadsheet",
    caDisplayLabel: "",
    icon: "description",
    slug: "assessment-spreadsheet",
    isPinned: !0
  },
  ASSESSMENT_TRACKER: {
    monolithId: "15",
    monolithName: "Assessment Tracker",
    caDisplayLabel: "",
    icon: "description",
    slug: "assessment-tracker",
    isPinned: !0
  },
  BADGES: {
    monolithId: "16",
    monolithName: "Badges",
    caDisplayLabel: "",
    icon: "description",
    slug: "badges",
    isPinned: !1
  },
  BINGO: {
    monolithId: "17",
    monolithName: "Bingo",
    caDisplayLabel: "",
    icon: "description",
    slug: "bingo",
    isPinned: !1
  },
  BOARD_GAME: {
    monolithId: "18",
    monolithName: "Board Game",
    caDisplayLabel: "",
    icon: "description",
    slug: "board-game",
    isPinned: !1
  },
  BOOK_COVER: {
    monolithId: "19",
    monolithName: "Book Cover",
    caDisplayLabel: "",
    icon: "description",
    slug: "book-cover",
    isPinned: !1
  },
  BOOKLET: {
    monolithId: "20",
    monolithName: "Booklet",
    caDisplayLabel: "",
    icon: "description",
    slug: "booklet",
    isPinned: !1
  },
  BOOKMARKS: {
    monolithId: "21",
    monolithName: "Bookmarks",
    caDisplayLabel: "",
    icon: "description",
    slug: "bookmarks",
    isPinned: !1
  },
  CALENDAR: {
    monolithId: "22",
    monolithName: "Calendar",
    caDisplayLabel: "",
    icon: "description",
    slug: "calendar",
    isPinned: !1
  },
  CERTIFICATE: {
    monolithId: "23",
    monolithName: "Certificate",
    caDisplayLabel: "",
    icon: "description",
    slug: "certificate",
    isPinned: !1
  },
  CHALLENGE_CARDS: {
    monolithId: "24",
    monolithName: "Challenge Cards",
    caDisplayLabel: "",
    icon: "description",
    slug: "challenge-cards",
    isPinned: !1
  },
  COLOURING_PAGE: {
    monolithId: "25",
    monolithName: "Colouring Page",
    caDisplayLabel: "",
    icon: "description",
    slug: "colouring-page",
    isPinned: !1
  },
  COMPOSABLE_AUDIO_EBOOK: {
    monolithId: "26",
    monolithName: "Composable Audio eBook",
    caDisplayLabel: "",
    icon: "description",
    slug: "composable-audio-ebook",
    isPinned: !1
  },
  COMPOSABLE_BINGO: {
    monolithId: "27",
    monolithName: "Composable Bingo",
    caDisplayLabel: "",
    icon: "description",
    slug: "composable-bingo",
    isPinned: !1
  },
  COMPOSABLE_HOTSPOTS: {
    monolithId: "28",
    monolithName: "Composable Hotspots",
    caDisplayLabel: "",
    icon: "description",
    slug: "composable-hotspots",
    isPinned: !1
  },
  COMPOSABLE_MATCHING_ACTIVITY: {
    monolithId: "29",
    monolithName: "Composable Matching Activity",
    caDisplayLabel: "",
    icon: "description",
    slug: "composable-matching-activity",
    isPinned: !1
  },
  COMPOSABLE_MULTIPLE_CHOICE_QUIZ: {
    monolithId: "30",
    monolithName: "Composable Multiple Choice Quiz",
    caDisplayLabel: "",
    icon: "description",
    slug: "composable-multiple-choice-quiz",
    isPinned: !1
  },
  COMPOSABLE_PUZZLE_STRIPS: {
    monolithId: "31",
    monolithName: "Composable Puzzle Strips",
    caDisplayLabel: "",
    icon: "description",
    slug: "composable-puzzle-strips",
    isPinned: !1
  },
  COMPOSABLE_READING_COMPREHENSION: {
    monolithId: "32",
    monolithName: "Composable Reading Comprehension",
    caDisplayLabel: "",
    icon: "description",
    slug: "composable-reading-comprehension",
    isPinned: !1
  },
  COMPOSABLE_SORTING_ACTIVITY: {
    monolithId: "33",
    monolithName: "Composable Sorting Activity",
    caDisplayLabel: "",
    icon: "description",
    slug: "composable-sorting-activity",
    isPinned: !1
  },
  COMPOSABLE_WORD_CARDS: {
    monolithId: "34",
    monolithName: "Composable Word Cards",
    caDisplayLabel: "",
    icon: "description",
    slug: "composable-word-cards",
    isPinned: !1
  },
  COMPOSABLE_WORD_GUESS_GAME: {
    monolithId: "35",
    monolithName: "Composable Word Guess Game",
    caDisplayLabel: "",
    icon: "description",
    slug: "composable-word-guess-game",
    isPinned: !1
  },
  COMPOSABLE_WORD_MAT_ACTIVITY: {
    monolithId: "36",
    monolithName: "Composable Word Mat Activity",
    caDisplayLabel: "",
    icon: "description",
    slug: "composable-word-mat-activity",
    isPinned: !1
  },
  COMPOSABLE_WORD_SEARCH: {
    monolithId: "37",
    monolithName: "Composable Word Search",
    caDisplayLabel: "",
    icon: "description",
    slug: "composable-word-search",
    isPinned: !1
  },
  CONTINUOUS_PROVISION_PLANNING_IDEAS: {
    monolithId: "38",
    monolithName: "Continuous Provision Planning Ideas",
    caDisplayLabel: "",
    icon: "description",
    slug: "continuous-provision-planning-ideas",
    isPinned: !0
  },
  CRAFT_INSTRUCTIONS: {
    monolithId: "39",
    monolithName: "Craft Instructions",
    caDisplayLabel: "",
    icon: "description",
    slug: "craft-instructions",
    isPinned: !1
  },
  CROSSWORD: {
    monolithId: "40",
    monolithName: "Crossword",
    caDisplayLabel: "",
    icon: "description",
    slug: "crossword",
    isPinned: !1
  },
  CUT_OUT: {
    monolithId: "41",
    monolithName: "Cut Out",
    caDisplayLabel: "",
    icon: "description",
    slug: "cut-out",
    isPinned: !1
  },
  DISCUSSION_CARDS: {
    monolithId: "42",
    monolithName: "Discussion Cards",
    caDisplayLabel: "",
    icon: "description",
    slug: "discussion-cards",
    isPinned: !1
  },
  DISPLAY_BANNER: {
    monolithId: "43",
    monolithName: "Display Banner",
    caDisplayLabel: "",
    icon: "description",
    slug: "display-banner",
    isPinned: !1
  },
  DISPLAY_BORDERS: {
    monolithId: "44",
    monolithName: "Display Borders",
    caDisplayLabel: "",
    icon: "description",
    slug: "display-borders",
    isPinned: !1
  },
  DISPLAY_BUNTING: {
    monolithId: "45",
    monolithName: "Display Bunting",
    caDisplayLabel: "",
    icon: "description",
    slug: "display-bunting",
    isPinned: !1
  },
  DISPLAY_LETTERING: {
    monolithId: "46",
    monolithName: "Display Lettering",
    caDisplayLabel: "",
    icon: "description",
    slug: "display-lettering",
    isPinned: !1
  },
  DISPLAY_PHOTOS: {
    monolithId: "47",
    monolithName: "Display Photos",
    caDisplayLabel: "",
    icon: "description",
    slug: "display-photos",
    isPinned: !1
  },
  DISPLAY_TIMELINE: {
    monolithId: "48",
    monolithName: "Display Timeline",
    caDisplayLabel: "",
    icon: "description",
    slug: "display-timeline",
    isPinned: !1
  },
  DOT_TO_DOT: {
    monolithId: "49",
    monolithName: "Dot to Dot",
    caDisplayLabel: "",
    icon: "description",
    slug: "dot-to-dot",
    isPinned: !1
  },
  EBOOK: {
    monolithId: "50",
    monolithName: "eBook",
    caDisplayLabel: "",
    icon: "description",
    slug: "ebook",
    isPinned: !1
  },
  FACT_CARDS: {
    monolithId: "51",
    monolithName: "Fact Cards",
    caDisplayLabel: "",
    icon: "description",
    slug: "fact-cards",
    isPinned: !1
  },
  FACT_FILE: {
    monolithId: "52",
    monolithName: "Fact File",
    caDisplayLabel: "",
    icon: "description",
    slug: "fact-file",
    isPinned: !1
  },
  FLASHCARDS: {
    monolithId: "53",
    monolithName: "Flashcards",
    caDisplayLabel: "",
    icon: "description",
    slug: "flashcards",
    isPinned: !1
  },
  GLOSSARY: {
    monolithId: "54",
    monolithName: "Glossary",
    caDisplayLabel: "",
    icon: "description",
    slug: "glossary",
    isPinned: !1
  },
  GREETINGS_CARDS: {
    monolithId: "55",
    monolithName: "Greetings Cards",
    caDisplayLabel: "",
    icon: "description",
    slug: "greetings-cards",
    isPinned: !1
  },
  GRID: {
    monolithId: "56",
    monolithName: "Grid",
    caDisplayLabel: "",
    icon: "description",
    slug: "grid",
    isPinned: !1
  },
  GUIDANCE: {
    monolithId: "57",
    monolithName: "Guidance",
    caDisplayLabel: "",
    icon: "description",
    slug: "guidance",
    isPinned: !0
  },
  GUIDE: {
    monolithId: "58",
    monolithName: "Guide",
    caDisplayLabel: "",
    icon: "description",
    slug: "guide",
    isPinned: !1
  },
  HOME_LEARNING_TASK: {
    monolithId: "59",
    monolithName: "Home Learning Task",
    caDisplayLabel: "",
    icon: "description",
    slug: "home-learning-task",
    isPinned: !1
  },
  INSTRUCTIONS: {
    monolithId: "60",
    monolithName: "Instructions",
    caDisplayLabel: "",
    icon: "description",
    slug: "instructions",
    isPinned: !1
  },
  INTERACTIVE_GAME: {
    monolithId: "61",
    monolithName: "Interactive Game",
    caDisplayLabel: "",
    icon: "description",
    slug: "interactive-game",
    isPinned: !1
  },
  INTERACTIVE_PDF_ACTIVITY: {
    monolithId: "62",
    monolithName: "Interactive PDF Activity",
    caDisplayLabel: "",
    icon: "description",
    slug: "interactive-pdf-activity",
    isPinned: !1
  },
  INTERACTIVE_WORD_SEARCH: {
    monolithId: "63",
    monolithName: "Interactive Word Search",
    caDisplayLabel: "",
    icon: "description",
    slug: "interactive-word-search",
    isPinned: !1
  },
  KNOWLEDGE_ORGANISER: {
    monolithId: "64",
    monolithName: "Knowledge Organiser",
    caDisplayLabel: "",
    icon: "description",
    slug: "knowledge-organiser",
    isPinned: !0
  },
  LABELS: {
    monolithId: "65",
    monolithName: "Labels",
    caDisplayLabel: "",
    icon: "description",
    slug: "labels",
    isPinned: !1
  },
  LANYARD_INSERTS: {
    monolithId: "66",
    monolithName: "Lanyard Inserts",
    caDisplayLabel: "",
    icon: "description",
    slug: "lanyard-inserts",
    isPinned: !1
  },
  LARGE_ACTIVITY_TRAY: {
    monolithId: "67",
    monolithName: "Large Activity Tray",
    caDisplayLabel: "",
    icon: "description",
    slug: "large-activity-tray",
    isPinned: !1
  },
  LEAFLET: {
    monolithId: "68",
    monolithName: "Leaflet",
    caDisplayLabel: "",
    icon: "description",
    slug: "leaflet",
    isPinned: !1
  },
  LESSON_PACK: {
    monolithId: "69",
    monolithName: "Lesson Pack",
    caDisplayLabel: "",
    icon: "description",
    slug: "lesson-pack",
    isPinned: !1
  },
  LESSON_PLAN: {
    monolithId: "70",
    monolithName: "Lesson Plan",
    caDisplayLabel: "",
    icon: "description",
    slug: "lesson-plan",
    isPinned: !0
  },
  LETTER_TEMPLATE: {
    monolithId: "71",
    monolithName: "Letter Template",
    caDisplayLabel: "",
    icon: "description",
    slug: "letter-template",
    isPinned: !1
  },
  LOOP_CARDS: {
    monolithId: "72",
    monolithName: "Loop Cards",
    caDisplayLabel: "",
    icon: "description",
    slug: "loop-cards",
    isPinned: !1
  },
  MAP: {
    monolithId: "73",
    monolithName: "Map",
    caDisplayLabel: "",
    icon: "description",
    slug: "map",
    isPinned: !1
  },
  MATCHING_CARDS: {
    monolithId: "74",
    monolithName: "Matching Cards",
    caDisplayLabel: "",
    icon: "description",
    slug: "matching-cards",
    isPinned: !1
  },
  MINI_BOOK: {
    monolithId: "75",
    monolithName: "Mini Book",
    caDisplayLabel: "",
    icon: "description",
    slug: "mini-book",
    isPinned: !1
  },
  NUMERACY_ASSESSMENT: {
    monolithId: "76",
    monolithName: "Numeracy Assessment",
    caDisplayLabel: "",
    icon: "description",
    slug: "numeracy-assessment",
    isPinned: !1
  },
  PAGE_BORDERS: {
    monolithId: "77",
    monolithName: "Page Borders",
    caDisplayLabel: "",
    icon: "description",
    slug: "page-borders",
    isPinned: !1
  },
  PLANNING_OVERVIEW: {
    monolithId: "78",
    monolithName: "Planning Overview",
    caDisplayLabel: "",
    icon: "description",
    slug: "planning-overview",
    isPinned: !0
  },
  PLAYDOUGH_MAT: {
    monolithId: "79",
    monolithName: "Playdough Mat",
    caDisplayLabel: "",
    icon: "description",
    slug: "playdough-mat",
    isPinned: !1
  },
  POEM: {
    monolithId: "80",
    monolithName: "Poem",
    caDisplayLabel: "",
    icon: "description",
    slug: "poem",
    isPinned: !1
  },
  POSTER: {
    monolithId: "81",
    monolithName: "Poster",
    caDisplayLabel: "",
    icon: "description",
    slug: "poster",
    isPinned: !1
  },
  POWERPOINT: {
    monolithId: "82",
    monolithName: "Powerpoint",
    caDisplayLabel: "",
    icon: "description",
    slug: "powerpoint",
    isPinned: !1
  },
  POWERPOINT_GAME: {
    monolithId: "83",
    monolithName: "PowerPoint Game",
    caDisplayLabel: "",
    icon: "description",
    slug: "powerpoint-game",
    isPinned: !1
  },
  PROGRESSION_OVERVIEW: {
    monolithId: "84",
    monolithName: "Progression Overview",
    caDisplayLabel: "",
    icon: "description",
    slug: "progression-overview",
    isPinned: !0
  },
  PUZZLE: {
    monolithId: "85",
    monolithName: "Puzzle",
    caDisplayLabel: "",
    icon: "description",
    slug: "puzzle",
    isPinned: !1
  },
  QUIZ: {
    monolithId: "86",
    monolithName: "Quiz",
    caDisplayLabel: "",
    icon: "description",
    slug: "quiz",
    isPinned: !1
  },
  READING_COMPREHENSION: {
    monolithId: "87",
    monolithName: "Reading Comprehension",
    caDisplayLabel: "",
    icon: "description",
    slug: "reading-comprehension",
    isPinned: !1
  },
  REASONING_CARDS: {
    monolithId: "88",
    monolithName: "Reasoning Cards",
    caDisplayLabel: "",
    icon: "description",
    slug: "reasoning-cards",
    isPinned: !1
  },
  RECIPE: {
    monolithId: "89",
    monolithName: "Recipe",
    caDisplayLabel: "",
    icon: "description",
    slug: "recipe",
    isPinned: !1
  },
  REWARD_CHARTS: {
    monolithId: "90",
    monolithName: "Reward Charts",
    caDisplayLabel: "",
    icon: "description",
    slug: "reward-charts",
    isPinned: !1
  },
  SCRIPT: {
    monolithId: "91",
    monolithName: "Script",
    caDisplayLabel: "",
    icon: "description",
    slug: "script",
    isPinned: !1
  },
  SENSORY_ACTIVITY: {
    monolithId: "92",
    monolithName: "Sensory Activity",
    caDisplayLabel: "",
    icon: "description",
    slug: "sensory-activity",
    isPinned: !1
  },
  SHEET_MUSIC: {
    monolithId: "93",
    monolithName: "Sheet Music",
    caDisplayLabel: "",
    icon: "description",
    slug: "sheet-music",
    isPinned: !1
  },
  STICKERS: {
    monolithId: "94",
    monolithName: "Stickers",
    caDisplayLabel: "",
    icon: "description",
    slug: "stickers",
    isPinned: !1
  },
  STORY: {
    monolithId: "95",
    monolithName: "Story",
    caDisplayLabel: "",
    icon: "description",
    slug: "story",
    isPinned: !1
  },
  SUCCESS_CRITERIA_GRIDS: {
    monolithId: "96",
    monolithName: "Success Criteria Grids",
    caDisplayLabel: "",
    icon: "description",
    slug: "success-criteria-grids",
    isPinned: !0
  },
  TABLE_SIGNS: {
    monolithId: "97",
    monolithName: "Table Signs",
    caDisplayLabel: "",
    icon: "description",
    slug: "table-signs",
    isPinned: !1
  },
  TEACHING_IDEAS: {
    monolithId: "98",
    monolithName: "Teaching Ideas",
    caDisplayLabel: "",
    icon: "description",
    slug: "teaching-ideas",
    isPinned: !0
  },
  TERM_PLANNER: {
    monolithId: "99",
    monolithName: "Term Planner",
    caDisplayLabel: "",
    icon: "description",
    slug: "term-planner",
    isPinned: !0
  },
  TEST: {
    monolithId: "100",
    monolithName: "Test",
    caDisplayLabel: "",
    icon: "description",
    slug: "test",
    isPinned: !1
  },
  TIMETABLE: {
    monolithId: "101",
    monolithName: "Timetable",
    caDisplayLabel: "",
    icon: "description",
    slug: "timetable",
    isPinned: !1
  },
  TOPIC_WEB: {
    monolithId: "102",
    monolithName: "Topic Web",
    caDisplayLabel: "",
    icon: "description",
    slug: "topic-web",
    isPinned: !1
  },
  UNIT_PACK: {
    monolithId: "103",
    monolithName: "Unit Pack",
    caDisplayLabel: "",
    icon: "description",
    slug: "unit-pack",
    isPinned: !1
  },
  VIDEO: {
    monolithId: "104",
    monolithName: "Video",
    caDisplayLabel: "",
    icon: "description",
    slug: "video",
    isPinned: !1
  },
  WORD_CARDS: {
    monolithId: "105",
    monolithName: "Word Cards",
    caDisplayLabel: "",
    icon: "description",
    slug: "word-cards",
    isPinned: !1
  },
  WORD_SEARCH: {
    monolithId: "106",
    monolithName: "Word Search",
    caDisplayLabel: "",
    icon: "description",
    slug: "word-search",
    isPinned: !1
  },
  WRITING_FRAMES: {
    monolithId: "107",
    monolithName: "Writing Frames",
    caDisplayLabel: "",
    icon: "description",
    slug: "writing-frames",
    isPinned: !1
  },
  TEST_DEV: {
    monolithId: "108",
    monolithName: "Test (Dev)",
    caDisplayLabel: "",
    icon: "description",
    slug: "test-dev",
    isPinned: !1
  }
};
export {
  D as T,
  g as p,
  l as r
};
//# sourceMappingURL=twinklResourceTypes.data-nGBA1g_Q.js.map
